// JsFromRoutes CacheKey 77b86b5f9b71d0ef1a8acbb0f33b472b
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  createGiftTip: /* #__PURE__ */ definePathHelper('post', '/places/:place_id/gift_tip'),
  editGiftTip: /* #__PURE__ */ definePathHelper('put', '/places/:place_id/gift_tip/:gift_tip_id'),
  deleteGiftTip: /* #__PURE__ */ definePathHelper('delete', '/places/:place_id/gift_tip/:gift_tip_id'),
}
